import React from 'react';

import {HEADERS} from '../../constants';

type Props = {
    columnId: string,
};

export const DefaultHeader = ({columnId}: Props) => (
    <strong>{HEADERS[columnId]}</strong>
);
